//@ts-check
import produce from 'immer';
import ACTIONS from './actions';
/**
 * @param {any} state
 * @param {any} action
 */

var formActionsReducer = function formActionsReducer(state, action) {
  if (!action) return state;

  switch (action.type) {
    case ACTIONS.SET_FORM_UPLOAD_FILE_CALLBACK:
      if (!action.payload) return state;
      return produce(state, function (draft) {
        draft.onUploadFile = action.payload;
      });

    default:
      break;
  }

  return state;
};

export default formActionsReducer;